import React, { useEffect, useRef, Fragment } from "react";
import "./Conversation.css";
import { useState } from "react";
// import { Form, div } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import moment from "moment/moment";
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRange, DateRangePicker } from "react-date-range";
import { addDays, subDays } from "date-fns";
import BotIcon from "../../assets/Vector.svg"
import Mood from "../../assets/mood.svg";
import Thunder from "../../assets/thunder.png"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import ResponsivePagination from 'react-responsive-pagination';
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Dialog, Transition } from '@headlessui/react'
import 'react-responsive-pagination/themes/classic.css';
import { fetchConversationList, fetchMessageList, multipleDeleteConversation } from "../../redux/actions/conversationActions";
import { FETCH_CONVERSATION_DATA, FETCH_CONVERSATION_LIST, FETCH_MESSAGE_LIST } from "../../constants/ConversationActionTypes";
import { DebounceInput } from "react-debounce-input";
import Loading from "../assetLibComponents/Loading";
import { Mixpanel } from "../../Mixpanel";
import {useLocation} from 'react-router-dom';
import Cookies from "js-cookie";




const Conversation = (props) => {
  const moment = require('moment');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const cancelButtonRef = useRef(null);
  const cancelButtonBotRef = useRef(null);
  const [page, setPage] = useState(1);
  const [deleteModal, setDeleteModal] = useState(false);
  const [sortByOption, setSortByOption] = useState("");
  const [limit, setLimit] = useState("");
  const [filterByOption, setFilterByOption] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [sideChat, setSideChat] = useState(false);
  const [showBotView, setShowBotView] = useState(false);
  const [selectedConversation, setSelectedConversation] = useState([]);
  const [rangeString, setRangeString] = useState(location.state?.startDate ?location.state?.rangeString:"all");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [moreIds, setMoreIds] = useState([]);
  const [dateRange, setDateRange] = React.useState(location.state?.startDate ? {
    startDate: location.state?.startDate,
    endDate: location.state?.endDate,
  } :{
    startDate: null,
    endDate: null,
  });
  const [selectedDates, setSelectedDates] = React.useState([
    {
      startDate: new Date(),
      endDate: null,
      key: 'selection',
    },
  ]);
  
  const conversationListing = useSelector(
    (state) =>state.conversation.conversationListing
  );
  const conversationData = useSelector(
    (state) =>state.conversation.conversationData
  );
  const messageListing = useSelector(
    (state) =>state.conversation.messageListing
  );
  const isLoading = useSelector(
    (state) =>state.conversation.loading
  );


  useEffect(() => {
    dispatch(fetchConversationList(props.authToken,dateRange?.startDate,dateRange?.endDate,1,"","","",""));
    setPage(1);
    setSelectedRow(null)
    setSideChat(false);
    setSearchValue("")
    setFilterByOption("")
    setSortByOption("")
    setLimit("")
  }, [dateRange]);
  
  useEffect(() => {
    dispatch(fetchConversationList(props.authToken,dateRange?.startDate,dateRange?.endDate,page,searchValue,filterByOption,sortByOption,limit));
    setSelectedRow(null);
    setSideChat(false);
  }, [page]);

  useEffect(() => {
    if(selectedRow){
      dispatch(fetchMessageList(props.authToken,selectedRow));
    }
  }, [selectedRow]);

  const handleCloseBot = () => {
    setShowBotView(false);
  }
  
  const handleCalendar = (ranges) => {
    setShowCalendar(false)
    const { startDate, endDate } = selectedDates[0];
  const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
  const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

  const formattedRange = {
    startDate: formattedStartDate,
    endDate: formattedEndDate,
  };

  setDateRange(formattedRange);
    
  };
  
  const deleteHandleClose = () => {
    setDeleteModal(false);
  };
  
  const containerRef = useRef(null);

 // Function to scroll to the top
 const scrollToTop = () => {
  // Check if the container ref exists
  if (containerRef.current) {
   // Access the DOM element of the container
   const container = containerRef.current;
   // Scroll to the top of the container
   container.scrollTop = 0;
  }
 };
  

  const handleMore = (id) => {
    setMoreIds((prevIds) => [...prevIds, id]);
  };

  const handleLess = (id) => {
    setMoreIds((prevIds) => prevIds.filter((prevId) => prevId !== id));
  };

  const handleTagClick = (buttonType) => {
    setShowCalendar(false);
    setSelectedConversation([]);
    const currentDate = moment();
    setRangeString(buttonType)
    setSelectedDates([
      {
        startDate: new Date(),
        endDate: null,
        key: 'selection',
      },
    ]);

  
    switch (buttonType) {
      case 'all':
        setDateRange({
          startDate: "",
          endDate: "",
        });
        break;
      case 'today':
        setDateRange({
          startDate: currentDate.format('YYYY-MM-DD'),
          endDate: currentDate.format('YYYY-MM-DD'),
        });
        break;
      case 'yesterday':
        setDateRange({
          startDate: currentDate.clone().subtract(1, 'day').format('YYYY-MM-DD'),
          endDate: currentDate.clone().subtract(1, 'day').format('YYYY-MM-DD'),
        });
        break;
      case 'lastWeek':
        setDateRange({
          startDate: currentDate.clone().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
          endDate: currentDate.clone().subtract(1, 'week').endOf('week').format('YYYY-MM-DD'),
        });
        break;
      case 'lastMonth':
        setDateRange({
          startDate: currentDate.clone().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          endDate: currentDate.clone().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
        });
        break;
      default:
        // Default case
        break;
    }
  };
  const handleRowSelection = (index) => {
    setSideChat(true);
    setSelectedRow(index)
    scrollToTop();
  };
  const handleSearch = (e) => {
    setSearchValue(e.target.value)
    dispatch(fetchConversationList(props.authToken,dateRange?.startDate,dateRange?.endDate,1,e.target.value,filterByOption,sortByOption,limit));
    setPage(1);
    setSelectedConversation([])
    setSelectedRow(null)
    setSideChat(false);
  };

  

  // useEffect(() => {
   
  //   if(conversationListing){
  //     Object.entries(conversationListing).map(([date, conversations],index) => {
  //       return (
  //       )})
  //   }
  // }, [])
  

  useEffect(() => { 
    Mixpanel.track("Accessed Conversations.")
    return () => {
      dispatch({
        type: FETCH_CONVERSATION_LIST,
        payload: null,
      });
     dispatch({
        type: FETCH_CONVERSATION_DATA,
        payload: null,
      });
    }
  }, [])
  
  const handleConvCheckboxChange = (e, obj) => {
    if (e.target.id !== "anchor_heading") {
      if (selectedConversation.includes(obj)) {
        setSelectedConversation(selectedConversation.filter(item => item !== obj));
      } else {
        setSelectedConversation([...selectedConversation, obj]);
      }
    }
  };
  
  const handleMultipleDelete = () => {
    const idsArray = selectedConversation.map(obj => obj.session_id);
    dispatch(multipleDeleteConversation(props.authToken, idsArray));
    setSelectedConversation([]);
  }
  
  const handleConvSelectAll = async () => {
    let convArray = [];
    const objectToArray = Object.values(conversationListing);
    await objectToArray.map(async (item) => {
      await item.map((innerItem) => {
        return convArray.push(innerItem);
      })
    })
    setSelectedConversation(convArray);
  }
  
  const handleConvUnSelectAll = () => {
    setSelectedConversation([])
  }

  useEffect(()=>{
    const uData = JSON.parse(localStorage.getItem("userData"));
    if(uData?.stripeData?.stripe_day_count === 0){
      //Do nothing
      navigate(`/404`);
    }
    props.pageTypeHandler("Conversation");
  },[])

  return (
    <>
      <div className="conversationContainer bg-gray-100 pt-[5rem] max-sm:pt-[4rem]">
        <div className="top mx-5 flex justify-between pb-4 pt-1 ">
          <div className="flex max-sm:block leftTop my-auto items-center relative">
            <div className="text-lg leading-7 font-[500] mr-2 max-sm:my-4">Conversation History</div>
            <div className="tagsContainer flex max-sm:mb-2">
              <div className={`bulletTags text-xs max-sm:text-[10px] border border-[#6B7280] text-[#6B7280] cursor-pointer mr-1  ${rangeString === "all" ? "bulletActive" : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)]"}`} onClick={()=>{handleTagClick("all");}}>All</div>
              <div className={`bulletTags text-xs max-sm:text-[10px] border border-[#6B7280] text-[#6B7280] cursor-pointer mr-1  ${rangeString === "today" ? "bulletActive" : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)]"}`} onClick={()=>{handleTagClick("today")}}>Today</div>
              <div className={`bulletTags text-xs max-sm:text-[10px] border border-[#6B7280] text-[#6B7280] cursor-pointer mr-1  ${rangeString === "yesterday" ? "bulletActive" : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)]"}`} onClick={()=>{handleTagClick("yesterday")}}>Yesterday</div>
              <div className={`bulletTags text-xs max-sm:text-[10px] border border-[#6B7280] text-[#6B7280] cursor-pointer mr-1  ${rangeString === "lastWeek" ? "bulletActive" : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)]"}`} onClick={()=>{handleTagClick("lastWeek")}}>Last Week</div>
              <div className={`bulletTags text-xs max-sm:text-[10px] border border-[#6B7280] text-[#6B7280] cursor-pointer mr-1  ${rangeString === "lastMonth" ? "bulletActive" : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)]"}`} onClick={()=>{handleTagClick("lastMonth")}}>Last Month</div>
            </div>
            <div className="flex flex-wrap">
              {dateRange.endDate !== null && rangeString === "calendar" && <div className={`bulletTags text-xs max-sm:text-[10px] cursor-pointer me-1 ${rangeString === "calendar" ? "bulletActive" : ""}`} onClick={() => { setShowCalendar(!showCalendar); setRangeString("calendar") }}>{dateRange?.startDate}/{dateRange?.endDate}</div>}
              {(selectedDates[0].endDate == null || dateRange.endDate == null) && <div className={`bulletTags text-xs  max-sm:text-[10px] border border-[#6B7280] text-[#6B7280] flex mr-1 my-auto cursor-pointer ${rangeString === "calendar" ? "bulletActive" : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)]"}`} onClick={()=>{setShowCalendar(!showCalendar);setRangeString("calendar");setDateRange({
                  startDate: null,
                  endDate: null,
                })}}>
                Choose Time Duration <Icon.CalendarDate className="ml-1 my-auto" />
              </div>}
            </div>
              {showCalendar && <div className="bulletTags bg-[white] left-3/4 top-[119%] z-10 border border-gray-400 max-sm:left-0 max-sm:top-full text-xs mr-1 my-auto absolute">
                <DateRange
                  editableDateInputs={true}
                  onChange={(ranges)=>{setSelectedDates([ranges.selection])}}
                  moveRangeOnFirstSelection={false}
                  ranges={selectedDates}
                  showMonthAndYearPickers={true}
                  showDateDisplay={false}
                  // initialFocusedRange={[17-18]}
                 />
                 <div className="flex w-full">
                  <div className="ms-auto flex">
                 <div className="calendarButton cursor-pointer mr-2" onClick={()=>setShowCalendar(false)}>Cancel</div>
                 <div className="calendarButton cursor-pointer" onClick={()=>{handleCalendar()}}>OK</div>
                  </div>
                 </div>
              </div>}
          </div>
        </div>
        <div className="bottom  grid grid-cols-12">
          <div className="col-span-8 max-sm:col-span-12 max-sm:h-[70vh] ml-4 mr-2">
            <div className={"h-[69%] max-sm:h-[85%] rounded-[20px] bg-white px-6 max-sm:px-4 pb-3 "+(selectedConversation.length > 0 ?" min-h-[76vh] max-sm:min-h-[30vh]":" min-h-[70vh] max-sm:min-h-[30vh]")}>
              <div className="w-full flex max-sm:block justify-between border-b border-gray-200 py-5">
                <div className="relative rounded-md shadow-sm my-auto max-sm:w-full max-sm:mb-4">
                  <DebounceInput
                      value={searchValue}
                      className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-300 sm:text-sm sm:leading-6"
                      placeholder="Search"
                      minLength={3}
                      debounceTimeout={500}
                      onChange={handleSearch}
                    />
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                      {searchValue && searchValue !== "" ? (
                          <Icon.X className="h-4 w-4 text-gray-400 pointer"/>
                        ) : (
                          <Icon.Search className="h-4 w-4 text-gray-400 cursor-pointer" onClick={handleSearch} />
                        )}
                    </div>
                </div> 
                <div className="flex justify-between">
                  <div className="flex rightTop">
                    <div className="filterContainer flex items-center mr-2">
                      <div className="filterText mr-2">Filter</div>
                      <div className="filterSelect">
                        <select
                          aria-label="select-sortby"
                          className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-[0.7rem]"
                          onChange={(e) => {
                            setFilterByOption(e.target.value);
                            let fiValue;
                            if (e.target.value === "null") {
                              fiValue = "";
                              // if(currFolderId) {
                              //   dispatch(fetchContentList(props.authToken, currFolderId, null, soValue, null, true));
                              // } else {
                              //   dispatch(fetchContentList(props.authToken, null, currCategoryId, null));
                              // }
                            } else {
                              fiValue = e.target.value;
                              dispatch(fetchConversationList(props.authToken,dateRange?.startDate,dateRange?.endDate,1,searchValue,fiValue,sortByOption));
                              setPage(1);
                              setSelectedRow(null)
                              setSideChat(false);
                              setSelectedConversation([])
                            }
                          }}
                          value={filterByOption}
                        >
                          {/* <option value="null">Any</option> */}
                          <option value="">All</option>
                          <option value="prospect">Prospect</option>
                          <option value="lead">Lead</option>
                        </select>
                      </div>
                    </div>
                    <div className="filterContainer flex items-center">
                      <div className="filterText mr-2">Sort By</div>
                      <div className="filterSelect">
                        <select
                          aria-label="select-sortby"
                          className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-[0.7rem]"
                          onChange={(e) => {
                            setSortByOption(e.target.value);
                            let soValue;
                            if (e.target.value === "null") {
                              soValue = "";
                              // if(currFolderId) {
                              //   dispatch(fetchContentList(props.authToken, currFolderId, null, soValue, null, true));
                              // } else {
                              //   dispatch(fetchContentList(props.authToken, null, currCategoryId, null));
                              // }
                            } else {
                              soValue = e.target.value;
                              dispatch(fetchConversationList(props.authToken,dateRange?.startDate,dateRange?.endDate,1,searchValue,filterByOption,soValue));
                              setPage(1);
                              setSelectedRow(null)
                              setSideChat(false);
                              setSelectedConversation([])
                            }
                          }}
                          value={sortByOption}
                        >
                          {/* <option value="null">Any</option> */}
                          <option value="date">Date</option>
                          <option value="title">Title</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {selectedConversation.length > 0 && <div className="flex text-xs text-[var(--brand-primary)] items-center justify-between px-4 max-sm:mx-0 max-sm:py-2 sm:px-6 py-5 sm:p-1.5 bg-[#F3F4F6] border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)]">
                <span className="max-sm:hidden">{selectedConversation.length} Selected</span>
                <div className="flex ml-auto mr-0 items-center">
                  <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-1.5 py-[5px] rounded-[6px] cursor-pointer ms-3 max-sm:ms-1" onClick={()=>{setDeleteModal(true)}}>
                        <Icon.Trash3/> <span>Delete</span>
                  </div>
                  <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-1.5 py-[5px] rounded-[6px] cursor-pointer ms-3 max-sm:ms-1" onClick={handleConvUnSelectAll}>
                        <Icon.Subtract/> <span>Unselect All</span>
                  </div>
                  <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-1.5 py-[5px] rounded-[6px] cursor-pointer ms-3 max-sm:ms-1" onClick={handleConvSelectAll}>
                      <Icon.UiChecks/> <span>Select All</span>
                  </div>
                </div>
              </div>  }
              {/* summary listing */}
              <div className={`overflow-y-auto listing max-h-[55vh] flex flex-col ${conversationListing && Object.entries(conversationListing).length > 0 ? "": "h-100 max-sm:h-[50vh]"} ${selectedConversation.length > 0 ?"max-sm:max-h-[34vh]":"max-sm:max-h-[39vh]"}`} >
              {(isLoading) && <Loading />}
              {conversationListing && Object.entries(conversationListing).length > 0 ? Object.entries(conversationListing).map(([date, conversations],index) => {
                return (
                  <div key={date}>
                    <div className="dateBar my-3 py-2 pl-2">{moment(date).format('ddd, D MMMM YYYY')}</div>
                    {conversations?.length > 0 && conversations.map(conversation => (
                        <div className={`summaryRow flex max-sm:block items-center border-b border-gray-200 py-2 ${selectedRow === conversation?.session_id ? "summaryRowActive" : ""}`}>
                          <div className="max-sm:w-full flex items-center w-[35%]">
                            <div className="listing-check my-auto flex">
                              <input
                                type="checkbox"
                                className="me-2 w-[12px] h-[12px]"
                                onChange={(e) => handleConvCheckboxChange(e, conversation)}
                                checked={selectedConversation.includes(conversation)}
                              />
                            </div>
                            <div className="w-[25%] max-sm:w-[30%] not-italic font-normal text-[10px] leading-3 text-[rgba(33,33,33,0.75)] text-left pl-2 pt-1">{conversation?.time}</div>
                            <div className="listingName w-[50%] max-sm:w-[60%] border-end text-start max-sm:contents flex flex-col my-auto">
                              <div title={conversation?.email} className={`w-[95%] max-sm:px-2 max-sm:w-[40%] overflow-hidden text-ellipsis whitespace-nowrap heading ${selectedRow === conversation?.session_id ? "listingNameActive" : ""} ${conversation?.lead_id && "cursor-pointer"}`} onClick={() => {conversation?.lead_id && navigate(`/Lead-Management/leadDetail/${conversation?.lead_id}`);}}>{conversation?.prospect_name == "Unknown" ? conversation?.email?.length > 0 ? conversation?.email?.length > 16 ?  `${conversation?.email.slice(0,16)}...` : conversation?.email  : conversation?.prospect_name : conversation?.prospect_name  }</div>
                              <div className={`flex max-sm:contents w-[95%] text-[rgba(33,33,33,0.75)] text-[10px] not-italic font-normal leading-3 subText max-sm:text-[12px] ${conversation?.designation?.length > 0 && "mt-1 max-sm:mt-0"} ${conversation?.company?.length > 0 && "mt-1 max-sm:mt-0"}`}>
                                <div className="w-full max-sm:w-[75%] overflow-hidden text-ellipsis whitespace-nowrap" title={`${conversation?.designation} , ${conversation?.company}`}>{conversation?.designation?.length > 0 && conversation?.designation}{conversation?.company?.length > 0 && conversation?.designation?.length > 0 && ","}{conversation?.company?.length > 0 && conversation?.company}</div>
                              </div>
                            </div>
                            <div className="listingMessageCount text-center"><span className="circleBackground w-full">{conversation?.count}</span></div>
                          </div>
                          <div className="w-[65%] max-sm:mt-4 max-sm:w-full not-italic font-normal text-xs leading-[15px] text-[rgba(33,33,33,0.75)] cursor-pointer" onClick={() => {
                          handleRowSelection(conversation?.session_id);
                          setShowBotView(true);
                          }}
                          >
                            {conversation?.summary}
                          </div>
                        </div>
                      ))}
                    </div>
             )}):<div className="text-[rgba(33,33,33,0.3)] text-[17px] py-[10%] font-[bolder] text-center h-full font-add">
                <span className="flex justify-center items-center text-[40px]">
                  <Icon.Inbox />
                </span>
                No Data
              </div>}
            </div>
              {/* summary listing */} 
            </div>
            {conversationData?.total_pages > 1 && <div className="flex my-2">
              <div className=" me-auto"><ResponsivePagination
               current={page}
               total={conversationData && conversationData?.total_pages}
               onPageChange={setPage}
              /></div>
              <div className="filterText me-2 my-auto">Limit</div>
              <div className="filterSelect me-5 my-auto">
                <select
                  aria-label="select-sortby"
                  className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                  onChange={(e) => {
                    setLimit(e.target.value);
                    let liValue;
                    if (e.target.value === "null") {
                      liValue = "";
                      // if(currFolderId) {
                      //   dispatch(fetchContentList(props.authToken, currFolderId, null, soValue, null, true));
                      // } else {
                      //   dispatch(fetchContentList(props.authToken, null, currCategoryId, null));
                      // }
                    } else {
                      liValue = e.target.value;
                      dispatch(fetchConversationList(props.authToken,dateRange?.startDate,dateRange?.endDate,1,searchValue,filterByOption,sortByOption,liValue));
                      setPage(1);
                      setSelectedConversation([]);
                      setSelectedRow(null)
                      setSideChat(false);
                    }
                  }}
                  value={limit}
                >
                  {/* <option value="null">Any</option> */}
                  <option value="">20</option>
                  <option value="40">40</option>
                  <option value="60">60</option>
                </select>
              </div>
              </div>}
          </div>
          {/* Chat panel Ui */}
          <div className="col-span-4 max-sm:hidden bottomRightContainer px-0 pt-4 ml-2 mr-4">
            <div className="bottomRight h-full px-3" ref={containerRef}>
           {sideChat && messageListing?.details?.length > 0 && messageListing?.details?.length > 0 ? <>
            {/* namaste */}
              <div className='first-left-response ml-4 mb-3'>
                <Icon.CaretRightFill className='left-icon-triangle-conversation' color='#ffffff'/>
                {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                <p className='first-ai-heading'>SIA Says</p>
                <p className='first-ai-response-new' >{messageListing?.greeting_msg}</p>
              </div>

              {messageListing?.details?.length > 0 && messageListing?.details?.map((item) => (
             <>
              {/* right */}
              <div className='right-response ml-auto mr-4 mb-3'>
                  <Icon.CaretRightFill className='right-icon-triangle' color='#ffffff'/>
                  {/* <div className='ai-icon'><img src={Mood} alt="account_box" /></div> */}
                  <p className='ai-heading'>You</p>
                  <p className='ai-response'>{item?.question}</p>
                </div>

                {/* left */}
                <div className='first-left-response ml-4 mb-3'>
                  <Icon.CaretRightFill className='icon-shift' color='#ffffff'/>
                  {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                  <div className="flex mb-2 justify-between items-center">
                    <p className='not-italic font-semibold text-sm leading-[17px] text-[#59B3C6]'>SIA Says</p>
                      <a href="/Chat-Ai/tuning"
                        onClick={(e) => {
                          Cookies.set("p_id", `HISTORY${item.id}` );
                        }}
                        target="blank"
                        className="flex h-7 rounded-xl bg-[#F8F8F8] justify-center items-center gap-2.5 p-2.5"
                      >
                      <Icon.Pencil
                        className="cursor-pointer text-gray-400 hover:text-[var(--brand-primary)] text-[16px]"
                      />
                    </a>
                  </div>
                  <p className='ai-response' dangerouslySetInnerHTML={{ __html: item?.answer }}></p>
                  {/* {item?.urls && item?.urls?.length > 0 && item?.urls?.map((rank,r_index) => {
                        return (
                          <p key={"chatbot-know-more-msg-" + r_index} className={'know-more flex ' + (r_index === 0 && "know-more-border")}>
                              <img src={Thunder} alt='Thunder' />
                              <a href={rank.url}>{rank.title.length > 30 ? `${rank.title?.slice(0, 30)}...`: rank.title}</a>
                          </p>
                        )
                      }) } */}
                  {item?.urls && item?.urls?.length > 0 && <div className='know-more-borders'>
                      <div className='learn-more-heading'>Learn More :</div>
                      {item?.urls && item?.urls?.length > 0 && item?.urls?.map((rank, r_index) => {
                      return (<>
                      {r_index < (moreIds.includes(item?.id)? 5: 3) &&
                      <a key={"r_index_"+r_index} className={'know-mores'} target='blank' href={rank.url} title={rank.title}>{ r_index+1 +". " }{rank.title}</a>}
                      </>
                        )
                      })}
                      {moreIds.includes(item?.id) ? (
                          <div
                            className="know-mores-expand"
                            onClick={() => {
                              handleLess(item?.id);
                            }}
                          >
                            - See Less
                          </div>
                        ) :
                        item?.urls?.length > 3 && (
                          <div
                            className="know-mores-expand"
                            onClick={() => {
                              handleMore(item?.id);
                            }}
                          >{`+${item?.urls?.length - 3} More`}</div>
                        )}
                    </div>}
                  </div>
              {item?.counter_data && item?.counter_data?.length > 0 && item?.counter_data.map((c_item,c_index)=>{
                    return (
                      <>
                      <div className='counter-question-left-response ml-4 mb-3'>
                      <Icon.CaretRightFill className='left-icon-triangle-conversation' color='#59B3C6'/>
                      {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                      <p className='counter-ai-heading'>SIA Says</p>
                      <p className='first-ai-response-new' >{c_item?.question}</p>
                    </div>
                    {c_item?.counter_answer?.length > 0 && <div className='right-response ml-auto mr-4 mb-3'>
                  <Icon.CaretRightFill className='right-icon-triangle' color='#ffffff'/>
                  {/* <div className='ai-icon'><img src={Mood} alt="account_box" /></div> */}
                  <p className='ai-heading'>You</p>
                  <p className='ai-response'>{c_item?.counter_answer}</p>
                </div>}
                {c_item?.acknowledgement?.length > 0 && <div className='first-left-response ml-4 mb-3'>
                  <Icon.CaretRightFill className='icon-shift' color='#ffffff'/>
                  {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                  <p className='first-ai-heading'>SIA Says</p>
                  <p className='ai-response'>{c_item?.acknowledgement}</p>
              </div>}
                    </>
                    )
                  })}
             </>
            ))}
            </>:<>
            <div className='flex justify-center items-center h-full'>
              <div className="flex justify-center items-center my-auto flex-col">
              <img src={BotIcon} className="mx-auto" alt="BotIcon" width={50} height={60}/>
              <div className="chatBotEmptyMessage mx-auto mt-3">Start by selecting a</div>
              <div className="mx-auto chatBotEmptyMessage">conversation</div>
              </div>
            </div>
            </>}
            </div>
          </div>
        </div>
        
        {/* Preview modal  */}
        <Transition.Root show={showBotView} as={Fragment} className="sm:hidden">
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonBotRef} onClose={handleCloseBot}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative max-sm:w-full rounded-lg bg-[#f2f2f2] px-2 pb-4 pt-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:py-4 sm:px-4">
                    <div className="bottomRightContainer transform h-[70vh] listing overflow-y-auto overflow-x-hidden px-0 pt-4">
                      <div className="bottomRight h-full" ref={containerRef}>
                        {sideChat && messageListing?.details?.length > 0 && messageListing?.details?.length > 0 ? <>
                          {/* namaste */}
                            <div className='first-left-response ml-4 mb-3'>
                              <Icon.CaretRightFill className='left-icon-triangle-conversation' color='#ffffff'/>
                              {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                              <p className='first-ai-heading'>SIA Says</p>
                              <p className='first-ai-response-new' >{messageListing?.greeting_msg}</p>
                            </div>

                            {messageListing?.details?.length > 0 && messageListing?.details?.map((item) => (
                          <>
                            {/* right */}
                            <div className='right-response ml-auto mr-4 mb-3'>
                                <Icon.CaretRightFill className='right-icon-triangle' color='#ffffff'/>
                                {/* <div className='ai-icon'><img src={Mood} alt="account_box" /></div> */}
                                <p className='ai-heading'>You</p>
                                <p className='ai-response'>{item?.question}</p>
                              </div>

                              {/* left */}
                              <div className='first-left-response ml-4 mb-3'>
                                <Icon.CaretRightFill className='icon-shift' color='#ffffff'/>
                                {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                                <div className="flex mb-2 justify-between items-center">
                                  <p className='not-italic font-semibold text-sm leading-[17px] text-[#59B3C6]'>SIA Says</p>
                                    <a href="/Chat-Ai/tuning"
                                      onClick={(e) => {
                                        Cookies.set("p_id", `HISTORY${item.id}`);
                                      }}
                                      target="blank"
                                      className="flex h-7 rounded-xl bg-[#F8F8F8] justify-center items-center gap-2.5 p-2.5"
                                    >
                                    <Icon.Pencil
                                      className="cursor-pointer text-gray-400 hover:text-[var(--brand-primary)] text-[16px]"
                                    />
                                  </a>
                                </div>
                                <p className='ai-response' dangerouslySetInnerHTML={{ __html: item?.answer }}></p>
                                {/* {item?.urls && item?.urls?.length > 0 && item?.urls?.map((rank,r_index) => {
                                      return (
                                        <p key={"chatbot-know-more-msg-" + r_index} className={'know-more flex ' + (r_index === 0 && "know-more-border")}>
                                            <img src={Thunder} alt='Thunder' />
                                            <a href={rank.url}>{rank.title.length > 30 ? `${rank.title?.slice(0, 30)}...`: rank.title}</a>
                                        </p>
                                      )
                                    }) } */}
                                {item?.urls && item?.urls?.length > 0 && <div className='know-more-borders'>
                                    <div className='learn-more-heading'>Learn More :</div>
                                    {item?.urls && item?.urls?.length > 0 && item?.urls?.map((rank, r_index) => {
                                    return (<>
                                    {r_index < (moreIds.includes(item?.id)? 5: 3) &&
                                    <a key={"r_index_"+r_index} className={'know-mores'} target='blank' href={rank.url} title={rank.title}>{ r_index+1 +". " }{rank.title}</a>}
                                    </>
                                      )
                                    })}
                                    {moreIds.includes(item?.id) ? (
                                        <div
                                          className="know-mores-expand"
                                          onClick={() => {
                                            handleLess(item?.id);
                                          }}
                                        >
                                          - See Less
                                        </div>
                                      ) :
                                      item?.urls?.length > 3 && (
                                        <div
                                          className="know-mores-expand"
                                          onClick={() => {
                                            handleMore(item?.id);
                                          }}
                                        >{`+${item?.urls?.length - 3} More`}</div>
                                      )}
                                  </div>}
                                </div>
                            {item?.counter_data && item?.counter_data?.length > 0 && item?.counter_data.map((c_item,c_index)=>{
                                  return (
                                    <>
                                    <div className='counter-question-left-response ml-4 mb-3'>
                                    <Icon.CaretRightFill className='left-icon-triangle-conversation' color='#59B3C6'/>
                                    {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                                    <p className='counter-ai-heading'>SIA Says</p>
                                    <p className='first-ai-response-new' >{c_item?.question}</p>
                                  </div>
                                  {c_item?.counter_answer?.length > 0 && <div className='right-response ml-auto mr-4 mb-3'>
                                <Icon.CaretRightFill className='right-icon-triangle' color='#ffffff'/>
                                {/* <div className='ai-icon'><img src={Mood} alt="account_box" /></div> */}
                                <p className='ai-heading'>You</p>
                                <p className='ai-response'>{c_item?.counter_answer}</p>
                              </div>}
                              {c_item?.acknowledgement?.length > 0 && <div className='first-left-response ml-4 mb-3'>
                                <Icon.CaretRightFill className='icon-shift' color='#ffffff'/>
                                {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                                <p className='first-ai-heading'>SIA Says</p>
                                <p className='ai-response'>{c_item?.acknowledgement}</p>
                            </div>}
                                  </>
                                  )
                                })}
                          </>
                          ))}
                          </>:<>
                          <div className='flex justify-center items-center h-full'>
                            <div className="flex justify-center items-center my-auto flex-col">
                            <img src={BotIcon} className="mx-auto" alt="BotIcon" width={50} height={60}/>
                            <div className="chatBotEmptyMessage mx-auto mt-3">Start by selecting a</div>
                            <div className="mx-auto chatBotEmptyMessage">conversation</div>
                            </div>
                          </div>
                          </>}
                          </div>
                        </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        
        <Transition.Root show={deleteModal} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={deleteHandleClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl">
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                          <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                        </div>
                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                          <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                            Delete Conversation(s)?
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              Are you sure you want to delete the selected conversation(s)?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                        onClick={async () => {
                          handleMultipleDelete();
                          setSelectedConversation([]);
                          deleteHandleClose();
                        }}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        onClick={() => deleteHandleClose(false)}
                        ref={cancelButtonRef}
                      >
                        No
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </div>
    </>
  );
};

export default Conversation;

// {[...Array(2)].map(() => {
//             return ()})}

// 330
